var map = {
	"./american-pale-ale.jpg": "cc75",
	"./double-ipa.jpg": "1001",
	"./english-style-bitter.jpg": "0dbb",
	"./image-not-available.jpg": "82a1",
	"./stout-beer.jpg": "607a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca62";